import { render, staticRenderFns } from "./MasterSpeech.vue?vue&type=template&id=3fc7fe94&scoped=true&"
import script from "./MasterSpeech.vue?vue&type=script&lang=js&"
export * from "./MasterSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc7fe94",
  null
  
)

export default component.exports